<template>
  <div>
    <div class="w-all w-minw bd-sd-b hg-40 bg-c-ffffff">
      <div class="w-main m-auto">
        <div class="fr">
          <div class="hover-ucenter fl">
            <div class="top_ucenter fl fs-12 line-h40"></div>
          </div>

          <a class="fs-12 ftc-000000 line-h40 go-login more" href="/show" v-if="nickname!=null">
            <i class="iconfont icon-member p-l-20 hg-40 fl m-r-6"></i>
            您好，{{nickname}}
          </a>
          <a
            class="fs-12 ftc-000000 line-h40 go-login more"
            href="https://open.weixin.qq.com/connect/qrconnect?appid=wx21ff014f5ae9fbbb&redirect_uri=http://xspx.zhyww.cn&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect"
            v-if="nickname==null"
          >
            <i class="iconfont icon-member p-l-20 hg-40 fl m-r-6"></i>您好，请登录
          </a>
          <a href="/login" v-if="nickname!=null" class="fs-12 ftc-000000 line-h40 m-l-4 more">[退出]</a>
          <a href="/login" v-if="nickname==null" class="fs-12 ftc-000000 line-h40 m-l-4 more"></a>
          <span class="fs-12 ftc-000000 line-h40 m-l-15">|</span>

          <div class="fr m-l-15">
            <div class="my-lesson">
              <a v-if="nickname!=null" href="/cglist" class="fl fs-12 ftc-000000 line-h40">
                <i class="iconfont icon-play1 m-r-4"></i>作品列表
              </a>
              <a
                v-if="nickname==null"
                href="https://open.weixin.qq.com/connect/qrconnect?appid=wx21ff014f5ae9fbbb&redirect_uri=http://xspx.zhyww.cn&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect"
                class="fl fs-12 ftc-000000 line-h40"
              >
                <i class="iconfont icon-play1 m-r-4"></i>作品列表
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>

    <div class="toppic wall mb10">
      <div class="picself wall">
        <ul>
          <li>
            <a href="/Show">首页</a>
          </li>
          <li>
            <a href="/Show">活动启事</a>
          </li>
          <li>
            <a href="/cgzp">课改成果展评</a>
          </li>
          <li>
            <a href="/lwzp">原创成果展评</a>
          </li>
          <li>
            <a href="/hjcx">获奖查询</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="main w1200">
      <div style=" text-align: center;margin-bottom: 30px;font-size:15px;margin-top: 30px">请先完善个人信息</div>
      <div class="userform">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="姓名：" prop="username">
            <el-input v-model="ruleForm.username"></el-input>
          </el-form-item>
          <el-form-item label="联系电话：" prop="phone">
            <el-input v-model="ruleForm.phone"></el-input>
          </el-form-item>
          <el-form-item label="所在地区：" prop="schoolArea">
            <el-cascader
              style="width:100%"
              size="large"
              :options="options"
              v-model="ruleForm.schoolArea"
              @change="handleChange"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="学校名称：" prop="workUnit">
            <el-input v-model="ruleForm.workUnit"></el-input>
          </el-form-item>
          <el-form-item label="邮寄地址：" prop="shippingAddress">
            <el-input v-model="ruleForm.shippingAddress"></el-input>
          </el-form-item>
          <el-form-item label="所在学段：" prop="studySection">
            <el-select v-model="ruleForm.studySection" placeholder="请选择学段" style="width:100%">
              <el-option label="小学" value="1"></el-option>
              <el-option label="初中" value="2"></el-option>
              <el-option label="高中" value="3"></el-option>
              <el-option label="其他" value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="来源渠道" prop="post">
            <el-select v-model="ruleForm.post" placeholder="请选择渠道" style="width:100%">
              <el-option label="学术刊" value="学术刊"></el-option>
              <el-option label="小学刊" value="小学刊"></el-option>
              <el-option label="初中刊" value="初中刊"></el-option>
              <el-option label="高中刊" value="高中刊"></el-option>
              <el-option label="其他" value="其他"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div
      class="footer"
      style="background:url(('../../assets/images/foot.png')) top center no-repeat;"
    >
      <div class="menu">
        <div class="box">
          <a href="http://www.zhyww.cn/ywbs/bsjj/202006/115472.html" target="_blank">关于我们</a>&nbsp;|&nbsp;
          <a
            href="http://www.zhyww.cn/ywbs/bsjj/202006/115483.html"
            target="_blank"
          >联系我们</a>&nbsp;|&nbsp;
          <a
            href="http://www.zhyww.cn/ywbs/bsjj/202006/115484.html"
            target="_blank"
          >版权声明</a>
        </div>

        <div class="copyright">
          <p>语文网版权所有 未经书面授权 不得复制或建立镜像 晋公网安备14010902000073号</p>
          <p>
            增值电信业务经营许可证晋B2-20030007 新出网许（晋）字005号
            <a
              href="http://beian.miit.gov.cn/publish/query/indexFirst.action"
              target="_blank"
            >晋ICP备09011058号</a>
            <a
              href="http://webscan.360.cn/index/checkwebsite/url/www.zhyww.cn"
              name="f7c1c8d71288f01cb16d63638e8f82bc"
            >网站安全检测平台</a>
          </p>
        </div>

        <a href="http://webscan.qianxin.com/safe/detail/?query=www.zhyww.cn">
          <img
            border="0"
            src="http://webscan.qianxin.com/api/authcode?code=fd753cb81c61b4824c3645292d170f85"
            style="display: none;"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/base.css";
import "@/assets/xspx.css";
import { UpdateUser, GetUserInfoByid } from "@/request/api";
import { regionData, CodeToText, TextToCode } from "element-china-area-data";
export default {
  data() {
    return {
      isshow: false,
      nickname: null,
      ruleForm: {
        userId: "",
        username: "",
        phone: "",
        schoolArea: [],
        city: null,
        dist: null,
        shippingAddress: null,
        studySection: null,
        post:null,
        workUnit: null,
        openid: null
      },
      selectedOptions: [],
      options: regionData,
      rules: {
        username: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
        workUnit: [
          { required: true, message: "请输入学校名称", trigger: "blur" }
        ],
        shippingAddress: [
          { required: true, message: "请输入详细地址", trigger: "blur" }
        ],
        schoolArea: [
          { required: true, message: "请选择地区", trigger: "change" }
        ],
        studySection: [
          { required: true, message: "请选择学段", trigger: "change" }
        ],
        post: [
          { required: true, message: "请选择来源", trigger: "change" }
        ]
      }
    };
  },
  created() {
    var that = this;
    var openid = sessionStorage.getItem("openid");
    this.ruleForm.openid = openid;
    if (openid == null) {
      this.$router.push({ path: "/" });
    }
    this.nickname = sessionStorage.getItem("nickname");
    this.ruleForm.userId = sessionStorage.getItem("userId");
      GetUserInfoByid({ userId: that.ruleForm.userId })
        .then(function(response) {
          console.log("#####:" + response.data.states);
          if (response.data.states == 1) {
            that.ruleForm.username = response.data.data.username;
            that.ruleForm.phone = response.data.data.phone;
            that.ruleForm.workUnit = response.data.data.workUnit;
            that.ruleForm.shippingAddress = response.data.data.shippingAddress;
            that.ruleForm.studySection = response.data.data.studySection;
             that.ruleForm.post = response.data.data.post;

            var province = TextToCode[response.data.area[0]].code;
            var city =
              TextToCode[response.data.area[0]][response.data.area[1]].code;
            var dist =
              TextToCode[response.data.area[0]][response.data.area[1]][
                response.data.area[2]
              ].code;
            that.ruleForm.schoolArea = [province, city, dist];
            that.handleChange(that.ruleForm.schoolArea)
          } 
        })
        .catch(function(reason) {
          alert("error");
        });

  },
  methods: {
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log(that.ruleForm);
          UpdateUser(that.ruleForm).then(function(res) {
            console.log("res2222:", res.data.states);
            if (res.data.states == 1) {
              alert("完善信息成功！");
              sessionStorage.setItem("username", that.ruleForm.username);
              that.$router.push({ path: "/lwList" });
            } else {
              alert("完善信息失败，请重新填写");
              that.$router.push({ path: "/userHome" });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //省市区三级联动事件id→文字
    handleChange(value) {
      var that = this;
      this.schoolArea = value;
      console.log("schoolArea:" + this.schoolArea);
      var name = "";
      this.ruleForm.province = CodeToText[this.schoolArea[0]];
      this.ruleForm.city = CodeToText[this.schoolArea[1]];
      this.ruleForm.dist = CodeToText[this.schoolArea[2]];
      console.log(this.ruleForm.province);
      console.log(this.ruleForm.city);
      console.log(this.ruleForm.dist);
    },

  }
};
</script>
